import React, { useState, useRef } from "react"
import { Card, CardContent, Paper, Typography, makeStyles, useTheme } from "@material-ui/core"
import { Chart } from "react-google-charts"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { Skeleton } from "@material-ui/lab"
import { Refresh as RefreshIcon } from "@material-ui/icons"

const useStyles = makeStyles((theme) => ({
	root: {
		minHeight: "376px",
	},
	cardBody: {
		padding: 0,
		"&:last-child": {
			paddingBottom: 0,
		},
	},
	title: {
		color: theme.palette.grey.D300,
		fontWeight: 600,
		marginLeft: "20px",
	},
	skeletonWrapper: {
		padding: 15,
	},
	NoData: {
		minHeight: 300,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	cardHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		marginTop: "4px",
	},
	resetIcon: {
		color: theme.palette.grey.D100,
		cursor: "pointer",
		marginRight: "20px",
	},
}))

const EmailSender = ({ setSelectedReceiver = () => {}, rerenderChartHandle = {}, setRerenderChartHandle = () => {} }) => {
	const classes = useStyles()
	const theme = useTheme()
	const isSenderSelected = useRef(null)
	const [t] = useTranslation("global")

	const data = useSelector((state) => state.dashboard?.data?.email?.from?.slice(0, 10) || [])
	const isLoading = useSelector((state) => state.dashboard?.isLoading)

	const options = {
		title: "",
		height: 300,
		legend: "none",
		animation: {
			startup: true,
			duration: 1000,
			easing: "inAndOut",
		},
		colors: [theme.palette.dashboard.D10],
		chartArea: { left: 150, right: 40, top: 20, bottom: 30, width: "100%" },
		hAxis: { gridlines: { color: "none", zeroLineColor: "transparent" }, baselineColor: "none", textPosition: "none" },
		bar: { groupWidth: `${(25 * (data?.length - 1)) / 8}%` },
		bars: "horizontal",
	}

	return (
		<Card className={classes.root}>
			<CardContent className={classes.cardBody}>
				<div className={classes.cardHeader}>
					<Typography variant="subtitle1" className={classes.title}>
						{t("dashboard.emailSender")}
					</Typography>
					{/* <Typography variant="caption" style={{ color: theme.palette.grey.D100, cursor: "pointer", marginLeft: "120px" }}>
						{t("dashboard.showAll")}
					</Typography> */}
					<RefreshIcon
						ref={isSenderSelected}
						className={classes.resetIcon}
						onClick={() => {
							if (isSenderSelected.current?.style?.color) {
								setSelectedReceiver((prevData) => null)
								setRerenderChartHandle((prevData) => ({ count: prevData.count++ }))

								isSenderSelected.current.style.color = ""
							}
						}}
					/>
				</div>
				{isLoading ? (
					<div className={classes.skeletonWrapper}>
						<Skeleton variant="rect" width={"100%"} height={300} />
					</div>
				) : data?.length ? (
					<Chart
						key={rerenderChartHandle}
						chartType="BarChart"
						data={data}
						options={options}
						chartEvents={[
							{
								eventName: "ready",
								callback: ({ chartWrapper, google }) => {
									const chart = chartWrapper.getChart()
									google.visualization.events.addListener(chart, "click", (e) => {
										var selection = chart.getSelection()
										const index = parseInt(e?.targetID?.split("#")?.[2])
										if (index || index === 0) {
											setSelectedReceiver((prevData) => data?.[index + 1])
											isSenderSelected.current.style.color = theme.palette.grey.D300
										}
									})
								},
							},
						]}
					/>
				) : (
					<Typography variant="subtitle1" className={classes.NoData}>
						{t("dashboard.noDataFound")}
					</Typography>
				)}
			</CardContent>
		</Card>
	)
}

export default React.memo(EmailSender)
